import { axiosInstance as axios } from "services";

export const addCompanyNote = async ({ companyId, note }) => {
  const { data } = await axios.post(`/admin/subscription/company/${companyId}/notes`, { note });
  if (!data.success) throw new Error(data.error?.message || "Failed to add note");
  return data;
};

